import React, { useEffect, useState } from "react";
import Card from "../../components/Card";
import Icon from "../../components/Icon";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import TextInput from "../../components/TextInput";
import { UseApi } from "../../hooks/use-api";
import { UseDisclosure } from "../../hooks/use-disclosure";
import { GetNFTTemplates } from "../../Services/lib/nfttemplates";
import styles from "./Banner.module.sass";

const SearchProduct = ({ val, setVal, initLoad }) => {
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [{ isLoading }, getNFTs] = UseApi({
		service: GetNFTTemplates,
	});

	const [nfts, setNfts] = useState([]);
	const [search, setSearch] = useState("");
	const close_ = () => {
		onClose();
	};

	const getNFTs_ = async () => {
		setNfts([]);
		const res = await getNFTs({
			offset: 0,
			limit: 8,
			sortBy: "updatedAt",
			orderBy: "desc",
			status: "ALL",
			name: search,
		});
		if (res) {
			setNfts(
				res.nftTemplates.map((e) => {
					return {
						name: e.name,
						_id: e._id,
					};
				})
			);
		}
	};
	useEffect(() => {
		getNFTs_();
	}, []);

	const setVal_ = (e) => {
		setVal(e);
		close_();
	};

	const submitHandler = () => {
		console.log(search);
		getNFTs_();
	};
	return (
		<>
			{initLoad ? (
				<div className={styles.initLoader}>
					<Loader />
				</div>
			) : (
				<TextInput required value={val.name} onClick={onOpen} />
			)}
			<Modal visible={isOpen} onClose={close_}>
				<Card title="Search product" classTitle="title-yellow">
					<div className={styles.nameSearchForm}>
						<TextInput onChangeInput={setSearch} vlaue={search} />
						<button type="button" onClick={submitHandler} className="button">
							<Icon reicon="search" size="24" />
						</button>
					</div>
					{isLoading && (
						<div className={styles.loaderWrap}>
							<Loader />
						</div>
					)}
					<div className={styles.NftsWrap}>
						{nfts.map((e) => {
							return (
								<div onClick={() => setVal_(e)} className={styles.nftNames}>
									{e.name}
								</div>
							);
						})}
					</div>
				</Card>
			</Modal>
		</>
	);
};

export default SearchProduct;
